
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.336.336v.383c-.385.094-.633.221-.742.383-.11.156-.164.552-.164 1.187v6.758c0 .62.054 1.013.164 1.18.11.166.357.296.742.39V11H6.055v-.383c.37-.088.612-.208.726-.36.12-.155.18-.56.18-1.21V1.055H2.82v7.992c0 .65.06 1.055.179 1.21.125.152.37.272.734.36V11H.445v-.383c.38-.094.628-.219.742-.375.115-.156.172-.555.172-1.195V2.289c0-.651-.062-1.052-.187-1.203C1.052.93.81.807.445.719V.336h8.89z","fill":"currentColor"}})])
          )
        }
      }
    